import { useEffect } from "react";
import { Link } from 'react-router-dom';
function Home() {
    useEffect(() => {
    window.scrollTo(0, 0);
    }, []);
  return (
    <div className="page">
        <div className='main'>
            <div className='dimBg'></div>
            <div className='container'>
                <div className='typo'>
                    당신의 비즈니스를 위한 최적의 IT 파트너.
                </div>
            </div>
        </div>
        <div className='goSub'>
            <div className='container'>
                <div className='title'>
                    오랜 경험과 기술력, KNO1996의 여정을 더 알아보세요.
                </div>
                <div className='linkWrap'>
                    <Link to='/company'>
                        <div className='dimBg2'></div>
                        <span>
                            회사소개
                        </span>
                    </Link>
                    <Link to='/business'>
                        <div className='dimBg2'></div>
                        <span>
                            비즈니스
                        </span>
                    </Link>
                    <Link to='/solution'>
                        <div className='dimBg2'></div>
                        <span>
                            솔루션
                        </span>
                    </Link>
                </div>
            </div>
        </div>
        <div className='t1Text'>
            <div className='dimBg'></div>
            <div className='container'>
                오랜 경험과 신뢰를 바탕으로 <br/>
                최고의 IT 솔루션을 제공합니다. <br/>
                KNO1996과 함께하세요.
            </div>
        </div>
    </div>
  );
}
export default Home;